import {
  AgendaCommercialeControllerApi,
  RptOpportunityPagedDto,
  RptOpportunitySearchDto,
  SearchOpportunityRequest,
  Configuration,
} from '@api/client';
import { createAction, createAsyncThunk } from '@reduxjs/toolkit';
import { ThunkApiConfig } from 'core/store';
import getConfiguration, { errorHandler } from 'core/store/config';

enum OpportunityActions {
  searchOpportunities = '[AgendaCommerciale] Search Opportunities',
  saveFiltersUsed = '[AgendaCommerciale] Save Opportunity Filters Used',
}

export const searchOpportunities = createAsyncThunk<
  RptOpportunityPagedDto | undefined,
  SearchOpportunityRequest,
  ThunkApiConfig
>(OpportunityActions.searchOpportunities, async (payload, { dispatch, extra, getState }) => {
  try {
    return await new AgendaCommercialeControllerApi(
      getConfiguration(Configuration, extra, getState)
    ).searchOpportunity(payload);
  } catch (e) {
    errorHandler(e, dispatch, getState);
  }
});

export const saveFiltersOpportunitiesUsed = createAction<RptOpportunitySearchDto>(
  OpportunityActions.saveFiltersUsed
);
